import type { AppBootstrap } from "@rakazo/contracts";

export type NavigationPreview = Pick<
  AppBootstrap,
  "me" | "bots" | "groups" | "botSections" | "spaces"
>;

// Keep the current account/space roster across app switches. Every Shell still refreshes it.
// This is an in-memory preview, never an authorization source or persisted chat data.
let preview: NavigationPreview | undefined;
export function rememberNavigation(value: NavigationPreview) {
  preview = value;
}
export function readNavigation(userId: string | undefined, spaceId: string | null | undefined) {
  if (
    !userId ||
    !spaceId ||
    !preview ||
    preview.me.userId !== userId ||
    preview.me.spaceId !== spaceId
  )
    return undefined;
  return preview;
}
